import axios from "axios";

import { defineStore } from "pinia";

export const useUserStore = defineStore({
  id: "user",
  state: () => ({
    user: null,
    username: {
      email: "",
      firstname: "",
      lastname: "",
      role: [],
      phone: null,
      ucc: "",
      totp: "",
      km: null,
      zoneMobileIOS: null,
      //    state: null,
    },
    currentUser: null,
    loading: false,
    error: null,
    dematDetails: null,
    boid: null,
  }),
  actions: {
    autoLogin(payload) {
      this.user = { id: payload };
    },
    Name(payload) {
      this.username = {
        firstname: payload?.["firstname"],
        lastname: payload?.["lastname"],
        email: payload?.["email"],
        role: payload?.["role"],
        phone: payload?.["phone"],
        ucc: payload?.["ucc"],
        totp: payload?.["totp"],
        km: payload?.["km"] || null,
        zoneMobileIOS: payload?.["zoneMobileIOS"] || null,
        // status: payload["status"],
      };
    },

    logout(payload) {
      return axios
        .post("/api/session/", { sub: payload.id })
        .then((response) => {
          if (response.data.loggedout == "true") {
            this.user = null;
            window.location.href =
              //  "https://sso.definedge.com/auth/realms/definedge/protocol/openid-connect/logout?redirect_uri=https%3A%2F%2Fwww.definedge.com";
              "https://signin.definedgebroking.com/auth/realms/debroking/protocol/openid-connect/logout?redirect_uri=https%3A%2F%2Fwww.definedgesecurities.com";
          }
        });
    },
  },
  getters: {
    getUserName: (state) => {
      debugger;
      return state.username;
    },
    userphone: (state) => {
      debugger;
      console.log("state: ", state);
      console.log("state username: ", state.username);
      console.log("state phone: ", state.username.phone);
      console.log("role: ", state.username.userrole);
      return state.username.phone;
    },

    admin: (state) => {
      debugger;
      // if(!state.username.role==null){
      var dummyrole = "";
      state.username.role.forEach((element) => {
        //  console.log('element :',element)
        if (element == "ROLE_ADM") {
          dummyrole = "ROLE_ADM";
        }
      });
      //console.log('Dummy role:', state.username.role)

      if (dummyrole == "ROLE_ADM") {
        return true;
      } else {
        return false;
      }
      //  }
    },
    payadmin: (state) => {
      debugger;
      var dummyrole = "";
      console.log("Roles", state.username.role);
      state.username.role.forEach((element) => {
        if (element == "BOPAY_ADMIN") {
          debugger;
          dummyrole = "BOPAY_ADMIN";
        }
      });
      if (dummyrole == "BOPAY_ADMIN") {
        return true;
      } else {
        return false;
      }
    },
    finadmin: (state) => {
      debugger;
      var dummyrole = "";
      state.username.role.forEach((element) => {
        if (element == "FINPAY_ADMIN") {
          dummyrole = "FINPAY_ADMIN";
        }
      });
      if (dummyrole == "FINPAY_ADMIN") {
        return true;
      } else {
        return false;
      }
    },
    aradmin: (state) => {
      debugger;
      var dummyrole = "";
      state.username.role.forEach((element) => {
        if (element == "AR_ADMIN") {
          dummyrole = "AR_ADMIN";
        }
      });
      if (dummyrole == "AR_ADMIN") {
        return true;
      } else {
        return false;
      }
    },
    userdata: (state) => {
      debugger;
      return state;
    },
    getUser: (state) => {
      debugger;
      var dummyrole = "";
      state.username.role.forEach((element) => {
        if (
          element == "joinlead" ||
          element == "BOPAY_ADMIN" ||
          element == "ROLE_ADM" ||
          element == "FINPAY_ADMIN" ||
          element == "AR_ADMIN"
        ) {
          dummyrole = element;
        }
      });
      if (
        dummyrole == "joinlead" ||
        dummyrole == "BOPAY_ADMIN" ||
        dummyrole == "ROLE_ADM" ||
        dummyrole == "FINPAY_ADMIN" ||
        dummyrole == "AR_ADMIN"
      ) {
        console.log("Joinlead role if condition");
        return false;
      } else {
        console.log("Joinlead role else condition");
        return true;
      }
      // }
    },
  },
});
